customElements.whenDefined('modal-dialog').then(() => {
  if (customElements.get('tw-guarantee-modal')) return;

  class TwGuaranteeModal extends customElements.get('modal-dialog') {
    constructor() {
      super();
      this.zoomButton = this.querySelector('[data-tw-guarantee-zoom]');
      this.viewport = this.querySelector('.tw-guarantee-modal__viewport');
      this.zoomButton.addEventListener('click', () => {
        this.setZoom(!this.hasAttribute('data-zoomed'));
      });
    }

    setZoom(zoomed) {
      this.toggleAttribute('data-zoomed', zoomed);
      this.zoomButton.setAttribute('aria-pressed', String(zoomed));
      this.zoomButton.textContent = zoomed ? 'Ganzes Label anzeigen' : 'Label vergrößern';
      this.viewport.scrollTo(0, 0);
    }

    show(opener) {
      // Start with the complete overview each time the notice opens.
      this.setZoom(false);
      this.querySelector('img').loading = 'eager';
      this.parentDrawer = opener.closest('cart-drawer.active');
      if (this.parentDrawer) {
        this.drawerWasInert = this.parentDrawer.inert;
        this.drawerAriaHidden = this.parentDrawer.getAttribute('aria-hidden');
      }
      super.show(opener);
      // Only the label is interactive while it sits above the open cart.
      if (this.parentDrawer) {
        this.parentDrawer.inert = true;
        this.parentDrawer.setAttribute('aria-hidden', 'true');
      }
    }

    hide() {
      if (!this.hasAttribute('open')) return;
      const drawer = this.parentDrawer;
      if (drawer) {
        drawer.inert = this.drawerWasInert;
        if (this.drawerAriaHidden === null) drawer.removeAttribute('aria-hidden');
        else drawer.setAttribute('aria-hidden', this.drawerAriaHidden);
      }
      const returnToCart = drawer?.isConnected && drawer.classList.contains('active');
      if (returnToCart && !this.openedBy?.isConnected) {
        this.openedBy = drawer.querySelector('[data-tw-guarantee-open]') ||
          drawer.querySelector('.drawer__inner');
      }
      super.hide();
      if (returnToCart) {
        document.body.classList.add('overflow-hidden');
        const container = drawer.classList.contains('is-empty')
          ? drawer.querySelector('.drawer__inner-empty')
          : drawer.querySelector('#CartDrawer');
        // Move focus first so Dawn reinstalls its boundary Tab handlers.
        drawer.querySelector('.drawer__inner').focus({ preventScroll: true });
        trapFocus(container, this.openedBy);
      }
      this.parentDrawer = null;
    }
  }

  customElements.define('tw-guarantee-modal', TwGuaranteeModal);

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-tw-guarantee-open]');
    if (!opener || event.defaultPrevented || event.button !== 0 ||
        event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const modal = document.getElementById(opener.getAttribute('aria-controls'));
    if (!modal || typeof modal.show !== 'function') return;
    event.preventDefault();
    modal.show(opener);
  });
});
